const styles = (theme) => ({
  container: {
    marginBottom: theme.spacing(2),
  },
});

export default styles;
